import { store } from "../../../../../redux/store";
import { ANCHOR_CLOUD } from "../CloudForm";
import {
    OWN_STATUS_IDLE,
    OWN_STATUS_LISTENING, OWN_STATUS_LOADING,
    OWN_STATUS_SUCCESS,
    OWN_STATUS_WAIT_AGREE
} from "../../../../../settings/content/deploymentOwn";
import { validateIP } from "../../../../../helpers/forms/validators/ip";

export function collectCloudMessages(data) {

    const {currentCloud, errorsInputs} = store.getState().deployment;
    const cloudForm = currentCloud?.config?.cloudForm;
    // config.cloudForm
    // console.log(currentCloud)

    let messages = [];

    if (!currentCloud?.config?.selfHosted) {
        if (cloudForm && !data.token) {
            let fields = [];
            const emptyMessage = 'Please fill in required credentials';
            const errorMessage = 'Some credentials are invalid';
            fields = cloudForm.filter(i => i.type === 'field');
            fields.map(field => {
                if (
                    field.required
                    && !messages.some(m => m.message === emptyMessage)
                    && !data[field.name]?.length
                ) {
                    messages.push({
                        message: emptyMessage,
                        type: 'warning',
                        container: ANCHOR_CLOUD,
                        block: 'cloud-form',
                        target: `anchor-${field.name}`,
                    })
                }
                if ((!isNaN(parseFloat(field.maxLength)) || !isNaN(parseFloat(field.minLength))) && !!data[field.name]?.length) {
                    if (data[field.name].length < parseFloat(field.minLength)) {
                        messages.push({
                            message: `Minimum length is ${field.minLength} characters`,
                            type: 'error',
                            container: ANCHOR_CLOUD,
                            block: 'cloud-form',
                            target: `anchor-${field.name}`,
                        })
                    }
                    if (data[field.name].length > parseFloat(field.maxLength)) {
                        messages.push({
                            message: `Maximum length is ${field.maxLength} characters`,
                            type: 'error',
                            container: ANCHOR_CLOUD,
                            block: 'cloud-form',
                            target: `anchor-${field.name}`,
                        })
                    }
                }

                if (
                    !!errorsInputs[field.name]
                    && !messages.some(m => m.message === errorMessage)
                ) {
                    messages.push({
                        message: errorMessage,
                        type: 'error',
                        container: ANCHOR_CLOUD,
                        block: 'cloud-form',
                        target: `anchor-${field.name}`,
                    })
                }
            })
        }
    } else {
        switch (data.status) {
            case OWN_STATUS_LOADING:
                return [
                    {
                        message: `Hidden error to lock deploy button`,
                        type: `warning`,
                        container: 'own-form',
                    }, {
                        message: `Hidden error to lock deploy button`,
                        type: `error`,
                        container: 'own-form-hidden',
                    }
                ];
            case OWN_STATUS_WAIT_AGREE:
                return [{
                    message: `Agreement consent is required to continue`,
                    type: `error`,
                    container: 'own-form',
                    block: 'own-form',
                    target: 'own-form-agreement',
                }];
            case OWN_STATUS_IDLE:
                messages.push({
                    message: `Waiting for command copy`,
                    type: `warning`,
                    container: 'own-form',
                });
                messages.push({
                    message: `Hidden error to lock deploy button`,
                    type: `error`,
                    container: 'own-form-hidden',
                });
                break;
            case OWN_STATUS_LISTENING:
                messages.push({
                    message: `Waiting for connection`,
                    type: `warning`,
                    container: 'own-form',
                });
                messages.push({
                    message: `Hidden error to lock deploy button`,
                    type: `error`,
                    container: 'own-form-hidden',
                });
                break;
            case OWN_STATUS_SUCCESS:
                messages.push({
                    message: `Server is connected`,
                    type: `success`,
                    container: 'own-form',
                });
                break;
            default:
                messages.push({
                    message: !data.is_connected ? 'Server is not connected' : 'Server is connected',
                    type: !data.is_connected ? 'error' : 'success',
                    container: 'own-form',
                });
                messages.push({
                    message: `Hidden error to lock deploy button`,
                    type: `error`,
                    container: 'own-form-hidden',
                });
                break;
        }

        if (!data.srv_ip) {
            messages.push({
                message: 'Cannot be empty',
                type: 'error',
                container: 'own-form',
                block: 'own-form-inputs',
                target: `own-form-ip`,
            })
        } else {
            const {isValid, message} = validateIP(data.srv_ip, true);
            if (!isValid) {
                messages.push({
                    message,
                    type: 'error',
                    container: 'own-form',
                    block: 'own-form-inputs',
                    target: `own-form-ip`,
                })
            }
        }

        if (!data.ssh_port) {
            messages.push({
                message: 'Cannot be empty',
                type: 'error',
                container: 'own-form',
                block: 'own-form-inputs',
                target: `own-form-port`,
            })
        } else {
            if (isNaN(parseFloat(data.ssh_port))) {
                messages.push({
                    message: 'Can be only a whole number',
                    type: 'error',
                    container: 'own-form',
                    block: 'own-form-inputs',
                    target: `own-form-port`,
                })
            }
        }

        if (!data.ssh_user) {
            messages.push({
                message: 'Cannot be empty',
                type: 'error',
                container: 'own-form',
                block: 'own-form-inputs',
                target: `own-form-user`,
            })
        }
    }

    return messages
}